export default __webpack_public_path__ + "locales/lv/DownloadDialog.json?hash=1b681a5c90b126f3b6c1fe8d87195455";